import {
  Button,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Switch,
  Text,
  useDisclosure
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { RiDeleteBinLine, RiFileEditLine, RiLink } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CTable from "../../../components/Table/table";
import { buildStudentVideoUrl } from "../../../helpers/studentVideoLink";
import {
  openAddVideoFielsModel,
  openCreateVideos,
  openVideoChaptersModel,
} from "../../../modules/admin-modules/models/Actions";
import {
  deleteVideoRequest,
  suspendVideoRequest,
} from "../../../modules/admin-modules/videos/Actions";
import VideoPreviewModal from "./videoPreviewModal";
import AddVideoQuestionModal from "./models/add-video-question";


const VideosTable = ({ setAdd, setSelectedData, videos = [] }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.videos.isLoading);
  const [, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [, setSelected] = useState({
    id: "",
  });
  const [previewVideo, setPreviewVideo] = useState(null);
  const [questionVideo, setQuestionVideo] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isQuestionOpen,
    onOpen: onQuestionOpen,
    onClose: onQuestionClose,
  } = useDisclosure();
  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };

  const handleCopyStudentLink = async (data) => {
    const chapterId = data?.chapter?.id;
    if (!chapterId) {
      toast.error("لا يوجد فصل تابع لهذا الفيديو");
      return;
    }
    try {
      await navigator.clipboard.writeText(
        buildStudentVideoUrl({
          videoId: data?.id,
          chapterId,
          chapterName: data?.chapter?.name,
          sectionId: data?.chapter?.section_id,
          sectionName: data?.chapter?.section?.name,
        })
      );
      toast.success("تم نسخ الرابط");
    } catch {
      toast.error("فشل نسخ الرابط");
    }
  };

  useEffect(() => {
    setPageNumber(0);
  }, [videos]);

  const Data = videos?.map((data) => {
    return {
      ...data,
      id: data?.id,
      title: data?.title,
      chapter_id: data?.chapter?.id,
      chapter_name: data?.chapter?.name,
      suspend: (
        <Switch
          isChecked={data?.suspended == 1 ? true : false}
          onChange={() => {
            let formData = new FormData();
            formData.append("_method", "PUT");
            formData.append("suspended", data?.suspended == 1 ? 0 : 1);
            dispatch(
              suspendVideoRequest({
                formData: formData,
                id: data?.id,
              })
            );
          }}
        />
      ),
      publish_val: (
        <Text color="main_1" w="70px">
          {data?.publish == 0 ? "غير منشور " : " منشور"}
        </Text>
      ),
      add_fiels: (
        <Button
          bg="main_1"
          color="white"
          onClick={async () => {
            await setSelectedData(() => data);
            dispatch(openAddVideoFielsModel());
          }}
        >
          اضافة ملفات
        </Button>
      ),
      add_chapters: (
        <Button
          bg="main_1"
          color="white"
          size="sm"
          onClick={async () => {
            await setSelectedData(() => data);
            dispatch(openVideoChaptersModel());
          }}
        >
          Add Video Chapters
        </Button>
      ),
      add_question: (
        <Button
          bg="main_1"
          color="white"
          size="sm"
          onClick={() => {
            setQuestionVideo(data);
            onQuestionOpen();
          }}
        >
          سؤال الفيديو
        </Button>
      ),
      edit: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiFileEditLine />}
          onClick={async () => {
            await setSelectedData(() => data);

            await setSelected(() => data);
            await setAdd(false);

            await dispatch(openCreateVideos());
          }}
        />
      ),
      delete: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiDeleteBinLine color="red" />}
          onClick={() => {
            dispatch(deleteVideoRequest(data?.id));
          }}
        />
      ),
      view: (
        <Button
          bg="main_1"
          color="white"
          onClick={() => {
            viewData(data);
            setPreviewVideo(data);
            onOpen();
          }}
        >
          عرض
        </Button>
      ),
      copy_link: (
        <Button
          size="sm"
          bg="main_1"
          color="white"
          leftIcon={<RiLink />}
          onClick={(e) => {
            e.stopPropagation();
            handleCopyStudentLink(data);
          }}
        >
          نسخ الرابط
        </Button>
      ),
    };
  });
  const columns = [
    {
      Header: " عنوان الفيديو",
      accessor: "title",
    },
    {
      Header: "ID",
      accessor: "id",
    },
    {
      Header: "  الفصل التابع له",
      accessor: "chapter_name",
    },
    {
      Header: "  اضافة ملف",
      accessor: "add_fiels",
    },
    {
      Header: "Video Chapters",
      accessor: "add_chapters",
    },
    {
      Header: "سؤال الفيديو",
      accessor: "add_question",
    },
    {
      Header: "النشر",
      accessor: "publish_val",
    },
    {
      Header: "suspend",
      accessor: "suspend",
    },

    {
      Header: "تعديل",
      accessor: "edit",
    },
    // {
    //   Header: "حذف",
    //   accessor: "delete",
    // },
    {
      Header: "عرض",
      accessor: "view"
    },
    {
      Header: "نسخ الرابط",
      accessor: "copy_link",
    }
  ];

  const actions = (
    <Menu>
      <MenuButton
        as={IconButton}
        aria-label="Options"
        icon={<RiFileEditLine />}
        size="sm"
        fontSize="20px"
        variant="outline"
        border="none"
      />
      <MenuList>
        <MenuItem
          onClick={() => {
            setAdd(false);
            dispatch(openCreateVideos());
          }}
        >
          تعديل
        </MenuItem>
        <MenuItem
          onClick={() =>
          // dispatch(deleteClubRequest(selected?.id))
          {
            //console.log('test')
          }
          }
        >
          حذف
        </MenuItem>
      </MenuList>
    </Menu>
  );
  return (
    <>
      <CTable
        selectedData={viewData}
        Columns={columns}
        Data={Data}
        path={"openModel"}
        Actions={actions}
        Title={``}
        subTitle=""
        btnTitle=""
        placeHolder=""
        noSearchBar={true}
        noFilter={true}
        footerBtnTitle
        filterList
        addButton
        addButtonTitle=""
        setPage={setPage}
        setPerPage={setPerPage}
        currentpage={pageNumber}
        setPageNumber={setPageNumber}
        noSecondSearchBar={true}
        isLoading={isLoading}
        perPage={size}
        totalPage={Math.ceil(videos?.length / 10)}
      />
      <VideoPreviewModal
        isOpen={isOpen}
        onClose={onClose}
        videoData={previewVideo}
      />
      <AddVideoQuestionModal
        isOpen={isQuestionOpen}
        onClose={onQuestionClose}
        video={questionVideo}
      />
    </>
  );
};

export default VideosTable;
